import React, { useState } from "react";
import { useStudioWorkspace } from "../../firestoreStudio/context/StudioWorkspaceProvider";
import { useRuntimeConnection } from "../../firestoreStudio/runtime/StudioRuntimeProvider";
import { listRuntimeInstances } from "../../firestoreStudio/runtime/connectionRuntimeService";
import { useFirestoreAdmin } from "../context/FirestoreAdminProvider";

function Row({ label, value, mono = false }) {
  return (
    <div className="fa-inspector-row">
      <span className="fa-inspector-label">{label}</span>
      <span className={`fa-inspector-value${mono ? " mono" : ""}`}>{value ?? "—"}</span>
    </div>
  );
}

export default function FirestoreRuntimeInspector({ defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const { workspace } = useStudioWorkspace();
  const {
    connection,
    connectionId,
    projectId,
    app,
    firestore,
    auth,
    status,
    isActive,
    lastRuntimeRefresh,
    runtimeVersion,
    loading,
    error,
  } = useRuntimeConnection();
  const {
    collectionsLoaded,
    collectionsDiscovered,
    registryStatus,
    discoverySource,
  } = useFirestoreAdmin();

  const cachedInstances = listRuntimeInstances();
  const authUser = auth?.currentUser;

  return (
    <section className="fa-inspector fa-card">
      <button type="button" className="fa-inspector-head" onClick={() => setOpen((v) => !v)} aria-expanded={open}>
        <span className="material-symbols-outlined text-[18px]">memory</span>
        <strong>Runtime Inspector</strong>
        <span className={`fa-ws-pill fa-ws-status-${status === "connected" ? "live" : status === "error" ? "error" : "idle"}`}>
          {status}
        </span>
        {isActive && <span className="fa-ws-pill fa-ws-status-live">LIVE</span>}
        <span className="material-symbols-outlined ml-auto text-[18px]">
          {open ? "expand_less" : "expand_more"}
        </span>
      </button>
      {open && (
        <div className="fa-inspector-body">
          <Row label="Active Connection" value={connection?.name || workspace.connectionName || connectionId || "None"} />
          <Row label="Connection ID" value={connectionId || workspace.connectionId} mono />
          <Row label="Project ID" value={projectId || workspace.projectId} mono />
          <Row label="Firebase App" value={app?.name} mono />
          <Row label="Firestore App" value={firestore?.app?.name} mono />
          <Row label="Runtime Version" value={String(runtimeVersion)} mono />
          <Row label="Database" value={firestore?._databaseId?.database || "(default)"} mono />
          <Row
            label="Auth User"
            value={
              authUser
                ? `${authUser.email || authUser.uid}${authUser.isAnonymous ? " (anon)" : ""}`
                : loading ? "Connecting…" : "Not signed in"
            }
          />
          <Row label="Last Runtime Refresh" value={lastRuntimeRefresh} mono />
          <Row label="Collections Loaded" value={String(collectionsLoaded)} />
          <Row label="Collections Discovered" value={String(collectionsDiscovered)} />
          <Row label="Registry Status" value={registryStatus || "—"} />
          <Row label="Discovery Source" value={discoverySource || "—"} />
          <Row label="Cached Runtimes" value={cachedInstances.join(", ") || "none"} mono />
          {error && <p className="fa-inspector-error">{error}</p>}
        </div>
      )}
    </section>
  );
}
